"use client";

import { TariffsTable } from "./TariffsTable";
import { useNavigate, useSearchParams } from "react-router";
import Icon from "../../components/Icon";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Alert, Container } from "react-bootstrap";
import { useLicense } from "../../hooks/useLicense";
import { WebSocketContext } from "../../websocket/websocket";
import { LIMIT_INFO } from "../../eventsDispatcher/eventTypes";
import { useContext } from "react";
import { OBJECT_TYPE } from "../../eventsDispatcher/eventTypes";

const entityNames: Record<string, string> = {
    limit_life_part: "ещё одну часть",
    limit_trackers: "ещё один трекер",
    limit_lists: "ещё один список",
    limit_tasks: "ещё одну задачу",
    limit_checklists: "ещё один чек-лист",
    limit_my_wheels: "ещё один баланс",
    limit_client_wheels: "ещё один баланс клиента",
};

const limitLabels: Record<string, string> = {
    limit_life_part: "частей в балансе",
    limit_trackers: "трекеров",
    limit_lists: "списков",
    limit_tasks: "задач",
    limit_checklists: "чек-листов",
    limit_my_wheels: "моих балансов",
    limit_client_wheels: "балансов клиентов",
};

export default function TariffsPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { licenseInfo } = useLicense();
    const websocket = useContext(WebSocketContext);

    const reason = searchParams.get("reason");
    const isLimitExceeded = reason === "limit_exceeded";

    // Для обычных причин (например, limit_tasks)
    const limitKey = isLimitExceeded ? null : reason;
    const entityName = limitKey ? entityNames[limitKey] : null;
    const limitLabel = limitKey ? limitLabels[limitKey] : null;

    // Проверяем наличие предупреждений о лимите
    const hasLimitWarning = websocket?.limitWarnings && websocket.limitWarnings.size > 0;
    // Для подсветки превышенных лимитов в таблице
    let exceededLimits: string[] = [];
    if (hasLimitWarning) {
        exceededLimits = Array.from(websocket.limitWarnings);
    } else if (limitKey) {
        const info = LIMIT_INFO[limitKey as OBJECT_TYPE];
        if (info) {
            // Находим ключ OBJECT_TYPE по limitKey (инвертируем LIMIT_INFO)
            const objectType = Object.keys(LIMIT_INFO).find(key => LIMIT_INFO[key as OBJECT_TYPE].limitKey === limitKey) as OBJECT_TYPE | undefined;
            if (objectType) {
                exceededLimits = [objectType];
            }
        }
    }

    const handleGoBack = () => {
        navigate(-1);
    };

    return <Container fluid><Row>
        <Col>
            <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <h2 className="mb-0">Тарифы</h2>
                    <button
                        className="btn btn-outline-secondary"
                        onClick={handleGoBack}
                        aria-label="Вернуться назад"
                    >
                        <Icon icon={faTimes} />
                    </button>
                </div>
                {/* Специальное сообщение при переходе из виджета состояния */}
                {isLimitExceeded && (
                    <Alert variant="warning" className="mb-3">
                        <strong>Часть объектов не может быть синхронизирована. Выберете подходящий тариф.</strong>
                    </Alert>
                )}
                {/* Старая логика: объяснение почему нельзя добавить объект */}
                {limitKey && entityName && limitLabel && !isLimitExceeded && (
                    <Alert variant="warning" className="mb-3">
                        Вы не можете добавить {entityName}, так как исчерпан лимит <strong>{limitLabel}</strong> на вашем текущем тарифе <strong>"{licenseInfo?.plan ?? "—"}"</strong>.
                    </Alert>
                )}
                <TariffsTable exceededLimits={exceededLimits} />
            </div>
        </Col>
    </Row>
    </Container>
}
